<p-toast [baseZIndex]="12000"></p-toast>
<div class="ui-g-12 bg" >
  <div class="ui-g-1 ui-md-2 ui-lg-3"></div>
  <div class="ui-g-12 ui-md-8 ui-lg-6 card">
    <div class="ui-g-12 ui-md-12 ui-lg-12 background">
      <div class="ui-g-12 p-text-left">
        <h2 class="title">Olvidé mi carnet <br> o número de empleado</h2>
      </div>
    </div>
      <div class="ui-g-12 ui-md-12 ui-sm-12">
        <div class="ui-g-12 ui-fluid" style="padding: 0;">
          <div *ngIf="selectedType == 0; then update"></div>
        </div>
        <div class="ui-g-12">
          <ng-template #update>
            <div class="cardGray3 ui-g-12 ui-md-12 ui-lg-12">
              <div class="ui-g-12">
                <h2 class="subTitle">Ingrese la siguiente información</h2>
              </div>
              <div class="ui-g-12">
                <div class="ui-g-12 form-group">
                  <form class="form-group-login"  [formGroup]="userform" (ngSubmit)="onSubmit(userform.value)">
                    <div class="ui-g-12">
                      <h4 class="subTitle2">Seleccione país</h4>
                      <p-dropdown [options]="items"  formControlName="countrySelected"  placeholder="{{countryTitle}}" optionLabel="nameCountry" [showClear]="true" [virtualScroll]="false" [itemSize]="33" [filter]="false"></p-dropdown>
                      <p-message severity="error" text="seleccione país" *ngIf="!userform.controls['countrySelected'].valid&&userform.controls['countrySelected'].dirty"></p-message>
                    </div>
                    <div class="ui-g-12">
                        <h4 class="subTitle2">Primer Nombre</h4>
                        <input formControlName="name" id="float-input-name" type="text" size="80"  pInputText >
                        <p-message severity="error" text="nombre completo es requerido" *ngIf="!userform.controls['name'].valid&&userform.controls['name'].dirty"></p-message>
                    </div>
                    <div class="ui-g-12">
                      <h4 class="subTitle2">Primer Apellido</h4>
                      <input formControlName="lastName" id="float-input-name" type="text" size="80"  pInputText >
                      <p-message severity="error" text="nombre completo es requerido" *ngIf="!userform.controls['lastName'].valid&&userform.controls['lastName'].dirty"></p-message>
                  </div>
                    <div class="ui-g-12">
                        <h4 class="subTitle2">Fecha de nacimiento</h4>
                        <!--<input formControlName="birthdate" id="float-input-birthdate" type="text" size="80"  pInputText >-->
                        <p-calendar formControlName="birthdate"  id="float-input-birthdate"  dateFormat="dd/mm/yy" placeholder="Fecha de nacimiento" yearNavigator="true" [yearRange]="yearRange" monthNavigator="true"  (keyup)="onKeyDate($event)"></p-calendar>
                        <p-message severity="error" text="fecha de nacimiento es requerido" *ngIf="!userform.controls['birthdate'].valid&&userform.controls['birthdate'].dirty"></p-message>
                    </div>
                    <div class="ui-g-12">
                      <h4 class="subTitle2">Correo electrónico</h4>
                      <input formControlName="email" id="float-input-email" type="email" size="40"  pInputText minlength="6" ngModel email>
                      <p-message severity="error" text="correo electrónico es requerido" *ngIf="!userform.controls['email'].valid&&userform.controls['email'].dirty"></p-message>
                    </div>
                    <div class="ui-g-12">
                      <div class="ui-g-12">
                        <h4 class="subTitle2">Número de teléfono</h4>
                      </div>
                      <div class="ui-g-6 ui-md-6 ui-sm-12">
                          <p-dropdown [options]="items"  formControlName="country"  placeholder="{{countryTitle}}" optionLabel="idCode" [showClear]="true" [virtualScroll]="false" [itemSize]="33" [filter]="false"></p-dropdown>
                          <p-message severity="error" text="seleccione país" *ngIf="!userform.controls['country'].valid&&userform.controls['country'].dirty"></p-message>
                      </div>
                      <div class="ui-g-6 ui-md-6 ui-sm-12">
                          <input id="float-input" type="text"   pInputText formControlName="phoneNumber" (keypress)='validate($event)' minlength="4" maxlength="12">
                          <p-message severity="error" text="número de teléfono es requerido" *ngIf="!userform.controls['phoneNumber'].valid&&userform.controls['phoneNumber'].dirty"></p-message>
                      </div>
                    </div>
                    <div class="ui-g-12">
                      <h4 class="subTitle2">Documento de identificación</h4>
                      <input id="float-input-dpi" type="text" size="30"  pInputText formControlName="dpi" (keypress)='validate($event)' minlength="6" maxlength="20">
                      <p-message severity="error" text="dpi es requerido" *ngIf="!userform.controls['dpi'].valid&&userform.controls['dpi'].dirty"></p-message>
                    </div>
                    <div class="ui-g-12">
                      <button class="ui-button ui-fluid btn" pButton type="submit" label="{{loginBtnTitle}}" [disabled]="!userform.valid" ></button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </ng-template>
          <div class="progress-spinner" *ngIf="env.isContentLoading">
            <img src="assets/images/Logo-1.gif" alt="" width="300px">
          </div>
        </div>
      </div>
  </div>
  <p-dialog [(visible)]="success"  [closable]="true" [style]="{width: '60vw'}">
    <div class="ui-g-12">
        <div class="ui-g-12 p-grid">
        <div class="ui-g-1 ui-md-2 ui-lg-2"></div>
        <div class="ui-g-12 ui-md-8 ui-lg-8 align">
            <img src="assets/images/authorization/message-authorization.png" alt="" style="width: 125px;">
            <h2 class="align title2 mgTop">¡Consulta exitosa!</h2>
            <h3 class="align noMg">Se ha completado la petición con éxito</h3>
            <h2 class="align noMg">El número de carnet es:</h2>
            <h2 class="align noMg">{{idCardNumber}}</h2>
            <div class="align noMg"> <button  pButton type="button" class="ui-button-primary btn-dv" style="width: 100%;" label="Aceptar" (click)="navigateComponent('login')"></button></div>  
        </div>   
        <div class="ui-g-1 ui-md-2 ui-lg-2"></div>
        
        </div>
    </div>
</p-dialog>
  <div class="ui-g-1 ui-md-2 ui-lg-3"></div>
    
  </div>
  
  